import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=2fe10d48&scoped=true"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe10d48",
  null
  
)

export default component.exports